import React from "react";
import {
  FormControl,
  OutlinedInput,
  Typography,
  Box,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { useState } from "react";
import Visibility from "@mui/icons-material/Visibility";
import { VisibilityOff } from "@mui/icons-material";
import { Eye } from "lucide-react";
import { EyeOff } from "lucide-react";

const InputText = ({
  label,
  placeholder,
  id,
  value,
  type,
  formik,
  name,
  flexDirection = "column",
  alignItems = "start",
  labelStyle = {},
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  return (
    <Box width="100%">
      <FormControl
        sx={{
          width: "100%",
          flexDirection: flexDirection,
          alignItems: alignItems,
          position: "relative",
        }}
        variant="standard"
      >
        <label
          style={{ margin: "10px 0", textWrap: "nowrap", ...labelStyle }}
          htmlFor={id}
        >
          {label}
          <span style={{ color: "red", marginLeft: "5px" }}>*</span>
        </label>
        <OutlinedInput
          placeholder={placeholder}
          id={id}
          onBlur={formik.handleBlur}
          name={name}
          type={showPassword ? "text" : type || "text"}
          value={value || ""}
          onChange={formik.handleChange}
          aria-describedby="my-helper-text"
          endAdornment={
            name === "password" || name === "confirmPassword" ? (
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  onClick={handleClickShowPassword}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                  sx={{ color: "black", marginRight: "1px" }}
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </IconButton>
              </InputAdornment>
            ) : null
          }
          sx={{
            width: "100%",
            "&:focus": {
              borderColor: "black !important",
              outlineColor: "black !important",
            },
          }}
          inputProps={{
            autoComplete: "new-password",
            form: {
              autocomplete: "off",
            },
          }}
        />
      </FormControl>
      {formik.touched[name] && formik.errors[name] && (
        <Typography sx={{ color: "red" }}>{formik.errors[name]}</Typography>
      )}
    </Box>
  );
};

export default InputText;
